export enum MarketingDataParam {
  PIXEL_ID = "pixelid",
  FBCL_ID = "fbclid",
  CODE = "code",
  C_ID = "cid",
  SUB_ID = "subid",
}

export interface MarketingData {
  [MarketingDataParam.PIXEL_ID]: string;
  [MarketingDataParam.FBCL_ID]: string;
  [MarketingDataParam.CODE]: string;
  [MarketingDataParam.C_ID]: string;
  [MarketingDataParam.SUB_ID]: string;
}
